import { normalizeLocationId } from "../../Survey/helpers/resolveLocationId";

/**
 * L&D-only: store survey location in localStorage the same way Normal survey login does
 * for a single non-global, non-tag location (or when location_id is in the URL).
 * Clears stale location/employees when this survey cannot resolve a location.
 */
export function applyLearningSurveyLocation(survey, locationIdFromUrl) {
  const fromUrl = normalizeLocationId(locationIdFromUrl);
  if (fromUrl) {
    localStorage.setItem("location", fromUrl);
    return fromUrl;
  }

  const locationIds = Array.isArray(survey?.location_id)
    ? survey.location_id
    : survey?.location_id != null && survey?.location_id !== ""
      ? [survey.location_id]
      : [];

  if (
    !survey?.is_global &&
    !survey?.tag_id &&
    locationIds.length === 1
  ) {
    const locationId = normalizeLocationId(locationIds[0]);
    if (locationId) {
      localStorage.setItem("location", locationId);
      return locationId;
    }
  }

  // This survey has no usable location — drop any leftover from a prior session.
  localStorage.removeItem("location");
  localStorage.removeItem("employees");
  return null;
}
